module.exports = __webpack_public_path__ + "fonts/fa-light-300.d325ae7.woff";